import { ShoppingCart, FlowerProduct, MemorialTree } from '../../types'
import { endpoints } from '../endpoints'
import { http } from '../http'

export const carts = {
  addTree: (cartID: string, product: MemorialTree): Promise<ShoppingCart> =>
    http.post(endpoints.memorialTreeShoppingCartItems(cartID), {
      memorial_tree_shopping_cart_items: {
        description: product.description,
        name: product.name,
        product_id: product.product_id,
        price_in_cents: product.price_in_cents,
        num_trees: product.num_trees,
      },
    }),
  addFlower: (cartID: string, product: FlowerProduct): Promise<ShoppingCart> =>
    http.post(endpoints.flowerShoppingCartItems(cartID), {
      flower_shopping_cart_items: {
        description: product.description,
        product_id: product.code,
        name: product.name,
        price: product.price,
      },
    }),
  removeTree: (cartID: string, productID: string): Promise<ShoppingCart> =>
    http.destroy(endpoints.deleteMemorialTreeShoppingCartItem(cartID, productID)),
  removeFlower: (cartID: string, product: FlowerProduct): Promise<ShoppingCart> =>
    http.destroy(endpoints.deleteFlowerShoppingCartItem(cartID, product.code)),
  create: (): Promise<ShoppingCart> => http.post(endpoints.carts),
  load: (cartID: string): Promise<ShoppingCart> => http.get(endpoints.cart(cartID)),
}
